import React, { useState, useContext } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { HiOutlineMenuAlt2, HiOutlineX } from 'react-icons/hi';
import LanguageContext, { strings } from '../contexts/language';
import headerPt from '../assets/images/header_pt.png';
import headerEn from '../assets/images/header_en.png';
import brFlag from '../assets/images/br.png';
import enFlag from '../assets/images/en.png';

export default function Header() {
    const { language, changeLanguage } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    const inscricaoItems = [
        { to: '/inscricao', label: t.menu_register },
        { to: '/inscricao-imprensa', label: t.menu_press_register },
    ];

    const imprensaItems = [
        { to: '#',  label: 'Press Release' },
        //{ to: '/noticias',  label: t.news_title },
    ];

    function NavItem({ to, label, className }) {
        const isActive = location.pathname === to;
        return (
            <Link to={to} className={`nav-link ${className} ${isActive ? 'active' : ''}`} onClick={() => setMobileOpen(false)}>
                {label}
            </Link>
        );
    }

    const isInscricao = ['/inscricao', '/inscricao-imprensa'].some(p => location.pathname.startsWith(p));
    const isImprensa  = ['/imprensa', '/noticias'].some(p => location.pathname.startsWith(p));

    return (
        <header className="header-menu">
            {/* Banner */}
            <div className="header-banner">
                <Link to="/">
                    <img
                        src={language === 'en' ? headerEn : headerPt}
                        alt="III Fórum de Finanças Climáticas e de Natureza"
                        className="header-banner-img"
                    />
                </Link>
            </div>

            {/* Navbar */}
            <nav className="header-navbar">
                <div className="header-navbar-inner">

                    {/* Mobile toggle */}
                    <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)} aria-label="Abrir menu">
                        <HiOutlineMenuAlt2 size={26} />
                    </button>

                    {/* Desktop Nav */}
                    <div className="desktop-nav">

                        {/* Início + Programação */}
                        <NavItem to="/" label={t.menu_home} className="h_color_1" />

                        <NavItem to="/programacao" label={t.menu_agenda} className="h_color_3" />

                        {/* Alteração 1: Inscreva-se logo após Programação */}
                        <div className="has-submenu">
                            <span className={`nav-link h_color_4 ${isInscricao ? 'active' : ''}`}>
                                {t.btn_register}
                            </span>
                            <div className="submenu">
                                {inscricaoItems.map(item => (
                                    <NavItem key={item.to} to={item.to} label={item.label} className="h_color_4" />
                                ))}
                            </div>
                        </div>

                        <NavItem to="/painelistas" label={t.menu_panelists} className="h_ch_color_2olor_6" />

                        {/* Imprensa */}
                        {/* <div className="has-submenu">
                            <span className={`nav-link h_color_5 ${isImprensa ? 'active' : ''}`}>
                                {t.press_title}
                            </span>
                            <div className="submenu">
                                {imprensaItems.map(item => (
                                    <NavItem key={item.to} to={item.to} label={item.label} className="h_color_5" />
                                ))}
                            </div>
                        </div> */}

                        {/* Alteração 2: Eventos oculto — não renderizado, rota mantida */}
                        {/* <NavItem to="/eventos" label={t.events_title} className="h_color_6" /> */}

                        {/* Alteração 3: Local antes de Edições Anteriores */}
                        <NavItem to="/local" label={t.menu_local} className="h_color_3" />

                        <div className="has-submenu">
                            <span className="nav-link h_color_4">{t.previous_editions}</span>
                            <div className="submenu">
                                <a href="https://climateandnaturefinanceforum.colab208.com.br/" target="_blank" rel="noreferrer" className="nav-link h_color_4">2025</a>
                                <a href="https://forumbrasileirodefinancasclimaticas.colab208.com.br/" target="_blank" rel="noreferrer" className="nav-link h_color_4">2024</a>
                            </div>
                        </div>

                        {/* Alteração 4: "Assista Aqui" — label via language.js */}
                        <Link to="/assistir" className="nav-link nav-btn-watch" onClick={() => setMobileOpen(false)}>
                            {t.salas_title}
                        </Link>

                    </div>

                    {/* Language switcher */}
                    <div className="lang-switcher">
                        <button className={`lang-btn ${language === 'pt' ? 'active' : ''}`} onClick={() => changeLanguage('pt')}>
                            <img src={brFlag} alt="PT" /><span>PT</span>
                        </button>
                        <span className="lang-divider">|</span>
                        <button className={`lang-btn ${language === 'en' ? 'active' : ''}`} onClick={() => changeLanguage('en')}>
                            <img src={enFlag} alt="EN" /><span>EN</span>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Mobile drawer */}
            {mobileOpen && (
                <div className="mobile-overlay" onClick={() => setMobileOpen(false)}>
                    <div className="mobile-drawer" onClick={e => e.stopPropagation()}>
                        <button className="mobile-close-btn" onClick={() => setMobileOpen(false)}>
                            <HiOutlineX size={26} />
                        </button>

                        <div className="mobile-nav-links">
                            {/* Início + Programação */}
                            <NavItem to="/" label={t.menu_home} className="h_color_1" />

                            <NavItem to="/programacao" label={t.menu_agenda} className="h_color_3" />

                            {/* Alteração 1: Inscreva-se logo após Programação */}
                            <div className="mobile-nav-group-title">{t.btn_register}</div>
                            {inscricaoItems.map(item => (
                                <NavItem key={item.to} to={item.to} label={item.label} className="mobile-nav-link mobile-sub h_color_4" />
                            ))}

                            <NavItem to="/painelistas" label={t.menu_panelists} className="h_ch_color_2olor_6" />

                            {/* Imprensa */}
                            {/* <div className="mobile-nav-group-title">{t.press_title}</div>
                            {imprensaItems.map(item => (
                                <NavItem key={item.to} to={item.to} label={item.label} className="mobile-nav-link mobile-sub h_color_5" />
                            ))} */}

                            {/* Alteração 2: Eventos oculto no mobile também */}
                            {/* <NavItem to="/eventos" label={t.events_title} className="mobile-nav-link h_color_6" /> */}

                            {/* Alteração 3: Local antes de Edições Anteriores */}
                            <NavItem to="/local" label={t.menu_local} className="mobile-nav-link h_color_3" />

                            <div className="mobile-nav-group-title">{t.previous_editions}</div>
                                <a href="https://climateandnaturefinanceforum.colab208.com.br/" target="_blank" rel="noreferrer" className="mobile-nav-link mobile-sub h_color_4">2025</a>
                                <a href="https://climateandnaturefinanceforum.colab208.com.br/" target="_blank" rel="noreferrer" className="mobile-nav-link mobile-sub h_color_4" onClick={() => setMobileOpen(false)}>2025</a>

                            {/* Alteração 4: Assista Aqui */}
                            <Link to="/assistir" className="mobile-nav-link nav-btn-watch" onClick={() => setMobileOpen(false)}>
                                {t.salas_title}
                            </Link>
                        </div>

                        <div className="mobile-lang">
                            <button className={`lang-btn ${language === 'pt' ? 'active' : ''}`} onClick={() => { changeLanguage('pt'); setMobileOpen(false); }}>
                                <img src={brFlag} alt="PT" /> PT
                            </button>
                            <span className="lang-divider">|</span>
                            <button className={`lang-btn ${language === 'en' ? 'active' : ''}`} onClick={() => { changeLanguage('en'); setMobileOpen(false); }}>
                                <img src={enFlag} alt="EN" /> EN
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
}
